/**
 * Layout — the shared logical-space constants. The scene is composed in a
 * fixed 1280x720 coordinate space and uniformly scaled to the real canvas.
 */
export const VIEW_W = 1280;
export const VIEW_H = 720;

export const SIDEWALK_W = 200; // start & finish pavement zones
export const LANE_W = 140;
export const MANHOLE_Y = 320;  // the single manhole row (screen-space Y)

export const CHICKEN_START_X = 116; // on the left sidewalk

export const laneCenterX = (lane) => SIDEWALK_W + (lane - 0.5) * LANE_W;
export const worldWidth = (lanes) => SIDEWALK_W * 2 + lanes * LANE_W;
